module.exports = __webpack_public_path__ + "img/kiosk_hero1.274f0755.png";